module.exports = __webpack_public_path__ + "img/headphones-box-bg.bac9580b.png";